var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportsFootballFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.25 41.45-14.7-14.7q-1 5.85-.4 9.625.6 3.775 1.15 4.325.55.55 4.225 1.15 3.675.6 9.725-.4Zm3.5-.75q2.9-.7 5.625-2.15T35.1 35.1q1.95-1.95 3.425-4.725Q40 27.6 40.7 24.75L23.25 7.3q-2.75.7-5.575 2.175Q14.85 10.95 12.9 12.9q-1.95 1.95-3.4 4.7t-2.2 5.65Zm-6.35-9-2.1-2.1 13.3-13.3 2.1 2.1Zm23.05-10.45q1-6 .4-9.7-.6-3.7-1.15-4.25-.55-.55-4.175-1.15-3.625-.6-9.775.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsFootballFilled);
export default __webpack_public_path__ + "static/media/sports_football_filled.09c0e2160584f54b215f3675185e3c03.svg";
export { ForwardRef as ReactComponent };